import ISupplierInfo from "../responses/ISupplierInfo";
import SupplierItem from '@/models/frontend/SupplierItem';
import Tenant from "./Tenant";
import Supplier from "./Supplier";

export default class SupplierWithItems extends Supplier {
  supplierItems: SupplierItem[];
  constructor(id: number, tenant: Tenant, code: string, name: string, email: string, customerCode: string, info: ISupplierInfo, supplierItems: SupplierItem[]) {
    super(id, tenant, code, name, email, customerCode, info);
    this.supplierItems = supplierItems;
  }
}